/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataStockGoodsListResVo } from './PageDataStockGoodsListResVo';
import {
    PageDataStockGoodsListResVoFromJSON,
    PageDataStockGoodsListResVoFromJSONTyped,
    PageDataStockGoodsListResVoToJSON,
    PageDataStockGoodsListResVoToJSONTyped,
} from './PageDataStockGoodsListResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataStockGoodsListResVo
 */
export interface ResponsePageDataStockGoodsListResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataStockGoodsListResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataStockGoodsListResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataStockGoodsListResVo}
     * @memberof ResponsePageDataStockGoodsListResVo
     */
    data?: PageDataStockGoodsListResVo;
}

/**
 * Check if a given object implements the ResponsePageDataStockGoodsListResVo interface.
 */
export function instanceOfResponsePageDataStockGoodsListResVo(value: object): value is ResponsePageDataStockGoodsListResVo {
    return true;
}

export function ResponsePageDataStockGoodsListResVoFromJSON(json: any): ResponsePageDataStockGoodsListResVo {
    return ResponsePageDataStockGoodsListResVoFromJSONTyped(json, false);
}

export function ResponsePageDataStockGoodsListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataStockGoodsListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataStockGoodsListResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataStockGoodsListResVoToJSON(json: any): ResponsePageDataStockGoodsListResVo {
    return ResponsePageDataStockGoodsListResVoToJSONTyped(json, false);
}

export function ResponsePageDataStockGoodsListResVoToJSONTyped(value?: ResponsePageDataStockGoodsListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataStockGoodsListResVoToJSON(value['data']),
    };
}

